import axios from "axios";
import { API_BASE_URL, getAuthConfig } from "./apiClient";

export const fetchFaqList = async () => {
  const response = await axios.get(`${API_BASE_URL}/faqs`);
  return response.data?.items || [];
};

export const createFaq = async ({ question, answer }) => {
  const response = await axios.post(
    `${API_BASE_URL}/faqs`,
    { question, answer },
    getAuthConfig(),
  );

  return response.data;
};

export const deleteFaq = async (faqId) => {
  await axios.delete(`${API_BASE_URL}/faqs/${faqId}`, getAuthConfig());
};
